import React, { useState } from "react";
import { connect } from "react-redux";
import { AxiosResponse } from "axios";
import { useLocation } from "react-router-dom";
import { NumericFormat } from "react-number-format";
import { BiLoaderCircle } from "react-icons/bi";

import {
  useAppDispatch,
  addOpenBets,
  clearExchangeBets,
  exchangeBetOddsChange,
  removeExchangeBet,
  setBettingInprogress,
  setExchangeBetStake,
  fetchCasinoOpenBets,
  fetchOpenBets,
  fetchBalance,
  BinaryBetrequest,
  BsResponse,
  PlaceBetRequest,
  ButtonVariable,
  EventDTO,
  PROVIDER_ID,
  triggerMultiFetchOrders,
  SelectedObj,
  setTriggerOrders,
  showToast,
  ToastDTO,
  RootState,
  useAppSelector,
} from "@hypexone/uicore";
import { isMobile } from "react-device-detect";
import Modal from "../shared/ModalComponent";
import { FaPlus } from "react-icons/fa6";
import { FaMinus } from "react-icons/fa";
import API from "../../../api";
import Button from "../shared/Button/Button";
import StakeSettings from "../user-menu-pages/StakeSettings";

interface BetSlipProps {
  balance: number;
  exposure: number;
  bets: PlaceBetRequest[];
  // oneClickAmount: number;
  // isOneClickEnable: boolean;
  selectedEventType: { id: ""; name: ""; slug: "" };
  fetchBalance: () => void;
  exchangeBetOddsChange: (index: number, odds: number) => void;
  removeExchangeBet: (index: number) => void;
  setExchangeBetStake: (
    index: number,
    amount: number,
    type: "ADD" | "SET"
  ) => void;
  eventData: EventDTO;
  clearExchangeBets: () => void;
  selectedEvent: SelectedObj;
  fetchOpenBets: (eventId: string[] | string, sportId?: string) => void;
  addOpenBets: (openBets) => void;
  buttonVariables: ButtonVariable[];
  bettingInprogress: boolean;
  cancelBetSuccess?: (betId: string) => void;
  setBettingInprogress: (val: boolean) => void;
  fetchCasinoOpenBets: (gType: string, mId: string) => void;
  mobileView?: boolean;
  setBetStartTime?: any;
  setAddNewBet?: any;
  showToast: Function;
}

const BetSlip: React.FC<BetSlipProps> = (props) => {
  const {
    balance,
    exposure,
    bets,
    eventData,
    fetchBalance,
    cancelBetSuccess,
    selectedEventType,
    exchangeBetOddsChange,
    removeExchangeBet,
    setExchangeBetStake,
    clearExchangeBets,
    selectedEvent,
    fetchOpenBets,
    addOpenBets,
    buttonVariables,
    bettingInprogress,
    setBettingInprogress,
    fetchCasinoOpenBets,
    setBetStartTime,
    setAddNewBet,
    showToast,
  } = props;

  const [showSpinner, setShowSpinner] = useState<boolean>(true);
  const jwt = sessionStorage.getItem("jwt_token");
  const location = useLocation();
  const dispatch = useAppDispatch();
  // const [progressCount, setProgressCount] = useState<number>(5);
  // const [
  //   progressCountRefreshInterval,
  //   setProgressCountRefreshInterval,
  // ] = useState<number>(1000);
  const { langData } = useAppSelector((state) => state.cms);
  const [showStakeModal, setShowStakeModal] = useState<boolean>(false);

  const betPlaceHandler = async () => {
    if (!sessionStorage.getItem("jwt_token")) {
      return showToast({
        type: "error",
        message: langData?.["login_to_place_bet_txt"],
      });
    }

    if (bets[0].amount < 1) {
      return showToast({
        type: "error",
        message: langData?.["minimum_stake_required_txt"],
      });
    }

    if (ValidateOdds(bets)) {
      return showToast({
        type: "error",
        message: langData?.["wrong_odds_txt"],
      });
    }

    if (+bets[0].oddLimt) {
      switch (bets[0].marketType) {
        case "MO":
          if (bets[0].oddValue > +bets[0].oddLimt) {
            return showToast({
              type: "error",
              message:
                langData?.["bet_rate_not_accepted_txt"] + bets[0].oddLimt,
            });
          }
          break;

        case "BM":
          if ((bets[0].oddValue + 100) / 100 > +bets[0].oddLimt) {
            return showToast({
              type: "error",
              message:
                langData?.["bet_rate_not_accepted_txt"] + bets[0].oddLimt,
            });
          }
          break;

        case "FANCY":
          if (bets[0].oddValue / 100 + 1 > +bets[0].oddLimt) {
            return showToast({
              type: "error",
              message:
                langData?.["bet_rate_not_accepted_txt"] + bets[0].oddLimt,
            });
          }
          break;
      }
    }

    if (
      (bets[0]?.minStake !== 0 && bets[0]?.minStake > bets[0].amount) ||
      (bets[0]?.maxStake !== 0 && bets[0]?.maxStake < bets[0].amount)
    ) {
      return showToast({
        type: "error",
        message: `${langData?.["minimum_stake_txt"]} ${bets[0]?.minStake} ${langData?.["maximum_stake_txt"]} ${bets[0]?.maxStake} `,
      });
    }

    if (!bets[0].oddValue) {
      showToast({
        type: "error",
        message: langData?.["invalid_odds_txt"],
      });
      return false;
    }

    let binaryPayload: BinaryBetrequest = null;
    let url = "";
    try {
      for (const data of bets) {
        // Cancel Bet for edit unMatched bet
        if (data.betId) {
          setAddNewBet(false);
          // await cancelBetHandler(data);

          const postBody = {
            cancelBets: [{ betId: data.betId, cancelSize: 0 }],
            marketId: data.marketId,
            eventId: data.eventId,
            sportId: data.sportId,
            seriesId: data.seriesId,
            // operatorId: OPERATORID,
            providerId: PROVIDER_ID,
          };

          try {
            const cancelResponse = await API.post(
              `/bs/cancel-sap-bet`,
              postBody,
              {
                headers: {
                  Authorization: sessionStorage.getItem("jwt_token"),
                },
              }
            );

            setShowSpinner(true);
            if (cancelResponse?.data?.status !== "RS_OK") {
              return showToast({
                type: "error",
                message: langData?.["cancel_old_bet_failed_txt"],
              });
            } else if (cancelResponse?.data?.status === "RS_OK") {
              cancelBetSuccess(data.betId);
            }
          } catch (err) {
            setShowSpinner(false);
            return showToast({
              type: "error",
              message: langData?.["cancel_bet_failed_txt"],
            });
          }
        }

        setBettingInprogress(true);
        switch (data.marketType) {
          case "MO": {
            url = "/place-matchodds-bet";
            break;
          }
          case "BM": {
            url = "/place-bookmaker-bet";
            break;
          }
          case "FANCY": {
            url = "/place-fancy-bet";
            break;
          }
          case "PREMIUM": {
            url = "/place-premium-bet";
            break;
          }
        }
      }

      setAddNewBet(true);
      let response: AxiosResponse<BsResponse>;
      try {
        response = await API.post("/bs" + url, bets[0], {
          headers: {
            Authorization: jwt,
          },
          timeout: 1000 * 20,
        });

        if (binaryPayload !== null) {
          response = await API.post("/binary/single-bet", binaryPayload, {
            headers: {
              Authorization: jwt,
            },
          });
        }
      } catch (e) {
        setShowSpinner(false);
        setBettingInprogress(false);
        return showToast({
          type: "error",
          message: e.response?.data?.message
            ? e.response?.data?.message
            : langData?.["general_err_txt"],
        });
      }

      if (response && response?.status === 200) {
        setBetStartTime(new Date());
      } else {
        showToast({
          type: "error",
          message: response?.data?.message
            ? response.data.message
            : langData?.["bet_placed_txt"],
        });
      }
    } catch (ex) {
      setBettingInprogress(false);
      setShowSpinner(false);
      if (ex.response) {
        showToast({
          type: "error",
          message: langData?.["bet_inprogress"],
        });
      } else {
        showToast({
          type: "error",
          message: langData?.["general_err_txt"],
        });
        return false;
      }
    }
  };

  const onChangeOddHandler = (
    index: any,
    data: PlaceBetRequest,
    control: number
  ) => {
    const isKhadoFancy =
      data.marketType === "FANCY" &&
      (data.oddType === "KHADO" ||
        (data.mcategory && data.mcategory.toLowerCase() === "khado"));

    if (data.oddValue === 1) {
      return false;
    }

    let value;
    if (control === 1) {
      let inc;
      if (isKhadoFancy) inc = 1;
      else if (data.oddValue < 2) inc = 0.01;
      else if (data.oddValue >= 2 && data.oddValue < 3) inc = 0.02;
      else if (data.oddValue >= 3 && data.oddValue < 4) inc = 0.05;
      else if (data.oddValue >= 4 && data.oddValue < 6) inc = 0.1;
      else if (data.oddValue >= 6 && data.oddValue < 10) inc = 0.2;
      else if (data.oddValue >= 10 && data.oddValue < 20) inc = 0.5;
      else if (data.oddValue >= 20 && data.oddValue < 30) inc = 1;
      else if (data.oddValue >= 30 && data.oddValue < 50) inc = 2;
      else if (data.oddValue >= 50 && data.oddValue < 100) inc = 5;
      else if (data.oddValue >= 100 && data.oddValue < 1000) inc = 10;
      else inc = 10;
      // value =
      //   data.marketType !== 'FANCY'
      //     ? data.marketType === 'CASINO'
      //       ? data.casinoOdds
      //       : (data.oddValue + inc).toFixed(2)
      //     : data.oddsSize;
      value =
        data.marketType !== "FANCY" || isKhadoFancy
          ? (data.oddValue + inc).toFixed(2)
          : data.oddValue.toFixed(2);
    } else {
      let inc;
      if (isKhadoFancy) inc = 1;
      else if (data.oddValue <= 2) inc = 0.01;
      else if (data.oddValue > 2 && data.oddValue <= 3) inc = 0.02;
      else if (data.oddValue > 3 && data.oddValue <= 4) inc = 0.05;
      else if (data.oddValue > 4 && data.oddValue <= 6) inc = 0.1;
      else if (data.oddValue > 6 && data.oddValue <= 10) inc = 0.2;
      else if (data.oddValue > 10 && data.oddValue <= 20) inc = 0.5;
      else if (data.oddValue > 20 && data.oddValue <= 30) inc = 1;
      else if (data.oddValue > 30 && data.oddValue <= 50) inc = 2;
      else if (data.oddValue > 50 && data.oddValue <= 100) inc = 5;
      else if (data.oddValue > 100 && data.oddValue <= 1000) inc = 10;
      else inc = 10;
      // value =
      //   data.marketType !== 'FANCY'
      //     ? data.marketType === 'CASINO'
      //       ? data.casinoOdds
      //       : (data.oddValue - inc).toFixed(2)
      //     : data.oddsSize;
      value =
        data.marketType !== "FANCY" || isKhadoFancy
          ? (data.oddValue - inc).toFixed(2)
          : data.oddValue.toFixed(2);
    }

    exchangeBetOddsChange(index, parseFloat(value.toString()));
  };

  const ValidateOdds = (bets: PlaceBetRequest[]) => {
    const matchOdds = eventData?.matchOdds?.runners;

    // Match Odds odd check
    if (matchOdds) {
      for (let bet of bets) {
        if (
          bet?.marketType === "MO" &&
          bet?.marketId === eventData?.matchOdds?.marketId
        ) {
          for (let mo of matchOdds) {
            if (mo.runnerId === bet.outcomeId) {
              if (bet.betType === "BACK") {
                if (mo?.backPrices) {
                  if (bet.oddValue <= mo.backPrices[0]?.price) {
                    return false;
                  } else {
                    return true;
                  }
                }
              } else {
                if (mo?.layPrices) {
                  console.log(mo.layPrices[0].price, "<=", bet.oddValue);
                  if (mo.layPrices[0]?.price <= bet.oddValue) {
                    return false;
                  } else {
                    return true;
                  }
                }
              }
            }
          }
        }
      }
    }
  };

  return (
    <>
      {bets?.length > 0 &&
        bets?.map((bet, index) => (
          <div className={bettingInprogress ? "relative opacity-75" : ""}>
            {bettingInprogress && !isMobile && (
              <BiLoaderCircle className="animate-spin absolute inset-0 m-auto h-8 w-8 opacity-75" />
            )}
            <div
              className={`${
                bet?.betType === "BACK" ? " bg-[#72BBEF] " : " bg-[#FAA9BA] "
              }`}
            >
              <div className="flex flex-col px-2">
                <span>{bet?.eventName}</span>
                <span className="text-xs">
                  {bet?.marketName}
                {bet?.oddType === "ODD_EVEN" ||
                    bet?.marketName?.includes("Odd Even Run Bhav")
                      ? `- ${bet?.outcomeDesc}`
                      : ``}
                </span>
              </div>
              {/* <div className="flex border-b-2 bg-gray-300 justify-between">
                <span className="w-[120px]">{langData?.['bet_for']}</span>
                <span className="w-[60px] text-center">{langData?.['odds']}</span>
                <span className="w-[60px] text-center">{langData?.['stake']}</span>
                <span className="w-[80px] text-center">{langData?.['profit']}</span>
              </div> */}
              <div
                className={`${
                  bet?.betType === "BACK" ? " bg-[#72BBEF] " : " bg-[#FAA9BA] "
                } flex items-center pt-1 justify-between mx-2 gap-2 `}
              >
                {/* <div className="w-[120px] text-sm flex">
                  <IoCloseSharp
                    color="red"
                    className="font-extrabold h-[24px] w-[24px] cursor-pointer"
                    onClick={() => removeExchangeBet(index)}
                  />
                  {bet?.marketName}
                </div> */}
                <div className="flex items-center w-full">
                  <Button
                    onClick={() => onChangeOddHandler(index, bet, 0)}
                    className="flex bg-gray-700 h-[30px] px-2 w-fit text-center items-center justify-center"
                    disabled={
                      bettingInprogress ||
                      (bet.marketType !== "MO" &&
                        !(bet.marketType === "FANCY" &&
                          (bet.oddType === "KHADO" ||
                            bet.mcategory?.toLowerCase() === "khado")))
                    }
                  >
                    <FaMinus color="white" />
                  </Button>
                  <input
                    type="number"
                    value={
                      bet?.displayOddValue ? bet?.displayOddValue : bet?.oddValue
                    }
                    readOnly
                    className="h-[30px] w-full text-center text-[12px]"
                  />
                  <Button
                    onClick={() => onChangeOddHandler(index, bet, 1)}
                    className="flex bg-gray-700 h-[30px] px-2 w-fit text-center items-center justify-center"
                    disabled={
                      bettingInprogress ||
                      (bet.marketType !== "MO" &&
                        !(bet.marketType === "FANCY" &&
                          (bet.oddType === "KHADO" ||
                            bet.mcategory?.toLowerCase() === "khado")))
                    }
                  >
                    <FaPlus color="white" />
                  </Button>
                </div>
                <NumericFormat
                  className="text-[12px] h-[30px] w-full leading-[30px] text-center text-black bg-white"
                  value={bet?.amount}
                  thousandSeparator={true}
                  thousandsGroupStyle="lakh"
                  allowNegative={false}
                  disabled={bettingInprogress}
                  onValueChange={(val) => {
                    setExchangeBetStake(index, val.floatValue, "SET");
                  }}
                />
                {/* <div className="w-[80px] text-right pr-2">
                  {bet.marketType === "MO"
                    ? bet.betType === "BACK"
                      ? (bet.amount * (bet.oddValue - 1)).toFixed(2)
                      : bet.amount.toFixed(2)
                    : bet.marketType === "BM"
                    ? bet.betType === "BACK"
                      ? (bet.amount * ((bet.oddValue + 100) / 100 - 1)).toFixed(
                          2
                        )
                      : bet.amount.toFixed(2)
                    : bet.marketType === "PREMIUM"
                    ? (bet.amount * (bet.oddValue - 1)).toFixed(2)
                    : bet.betType === "BACK"
                    ? (bet.amount * ((bet.oddValue + 100) / 100 - 1)) //size
                        .toFixed(2)
                    : bet.amount.toFixed(2)}
                </div>{" "} */}
                {/* Always 0 */}
              </div>
              <div
                className={`${
                  bet?.betType === "BACK" ? " bg-[#72BBEF] " : " bg-[#FAA9BA] "
                } mx-1 grid grid-cols-4 gap-1 my-2.5 text-[14px]  text-center whitespace-nowrap text-stone-900`}
              >
                {buttonVariables.slice(0, 8).map((button, btnIndex) => (
                  <Button
                    key={btnIndex}
                    onClick={() =>
                      setExchangeBetStake(index, button.stake, "ADD")
                    }
                    className="flex-1 rounded bg-[#ccc] border border-[#969494]"
                    style={{
                      color: "#000",
                    }}
                  >
                    {button.label}
                  </Button>
                ))}
              </div>

              <div className="flex justify-between mb-1 gap-1 mx-2">
                <Button
                  onClick={() =>
                    setExchangeBetStake(index, bet.minStake, "SET")
                  }
                  className="flex-1 w-full text-sm h-8 rounded text-black bg-[#e8e817]"
                >
                  {langData?.["min_stake"]}
                </Button>

                <Button
                  onClick={() =>
                    setExchangeBetStake(index, bet.maxStake, "SET")
                  }
                  className="flex-1 w-full  text-sm h-8 rounded  bg-blue-700 text-white"
                >
                  {langData?.["max_stake"]}
                </Button>

                <Button
                  onClick={() => setShowStakeModal(true)}
                  className="flex-1 w-full  text-sm h-8 rounded  bg-green-700 text-white"
                >
                  {langData?.["edit_stake"] ?? "Edit Stake"}
                </Button>

                <Button
                  onClick={() => setExchangeBetStake(index, 0, "SET")}
                  className="flex-1 w-full  text-sm h-8 rounded bg-red-600 text-white"
                >
                  {langData?.["clear"]}
                </Button>
              </div>
              <div className="flex justify-between pb-2 gap-1 mx-2">
                <Button
                  onClick={() => removeExchangeBet(index)}
                  className="flex-1 text-sm h-8 w-full rounded bg-red-600 text-white"
                >
                  {langData?.["reset"]}
                </Button>
                <Button
                  className={`flex-1 h-8 w-full border border-green-700 rounded text-sm bg-green-600 text-white`}
                  disabled={bettingInprogress}
                  onClick={betPlaceHandler}
                >
                  {langData?.["place_bet_txt"]}
                </Button>
              </div>
            </div>
          </div>
        ))}
      {showStakeModal && (
        <Modal
          isOpen={showStakeModal}
          onClose={() => setShowStakeModal(false)}
          title={langData?.["edit_stake"] ?? "Edit Stake"}
          isContentWidth
        >
          <StakeSettings />
        </Modal>
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    bets: state.betSlip.bets,
    selectedEvent: state.catalog.selectedEvent,
    selectedEventType: state.catalog.selectedEventType,
    buttonVariables: state.betSlip.buttonVariables,
    bettingInprogress: state.betSlip.bettingInprogress,
    oneClickAmount: state.betSlip.oneClickAmount,
    isOneClickEnable: state.betSlip.isOneClickEnable,
    balance: state.auth.balanceSummary.balance,
    exposure: state.auth.balanceSummary.exposure,
    openBets: state.betSlip.openBets,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    fetchBalance: () => dispatch(fetchBalance()),
    // cancelBetSuccess: (betId: string) => dispatch(cancelBetSuccess(betId)),
    exchangeBetOddsChange: (index: number, odds: number) =>
      dispatch(exchangeBetOddsChange({ index, odds })),
    removeExchangeBet: (index: number) => dispatch(removeExchangeBet(index)),
    setExchangeBetStake: (index: number, amount: number, type: "ADD" | "SET") =>
      dispatch(setExchangeBetStake({ index, amount, type })),
    fetchOpenBets: (eventId: string | string[], sportId?: string) =>
      dispatch(fetchOpenBets({ eventId, sportId })),
    addOpenBets: (openBets) => dispatch(addOpenBets(openBets)),
    setBettingInprogress: (val: boolean) => dispatch(setBettingInprogress(val)),
    fetchCasinoOpenBets: (gameType: string, mId: string) =>
      dispatch(fetchCasinoOpenBets({ gameType, mId })),
    showToast: (alert: ToastDTO) => dispatch(showToast(alert)),
    triggerMultiFetchOrders: (eventId: string) =>
      dispatch(triggerMultiFetchOrders(eventId)),
    setTriggerOrders: () => dispatch(setTriggerOrders()),
    clearExchangeBets: () => clearExchangeBets(),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BetSlip);
